import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 3000 },
    position: { type: String, default: "top-right" }
  }

  connect() {
    this.show()

    // Auto-dismiss after duration
    if (this.durationValue > 0) {
      this.timeout = setTimeout(() => this.hide(), this.durationValue)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  show() {
    this.element.classList.remove("hidden", "opacity-0")
    this.element.classList.add("animate-slide-in")
  }

  hide() {
    this.element.classList.add("animate-slide-out")
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  close() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.hide()
  }

  pauseTimer() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  resumeTimer() {
    if (this.durationValue > 0) {
      this.timeout = setTimeout(() => this.hide(), this.durationValue)
    }
  }
}
